import apiRequest from '../api/apiRequest';
import { StripeCustomer } from '../types';

export async function getStripeCustomer(stripeCustomerID: string) {
  return apiRequest<StripeCustomer>(
    'user',
    `/stripe/customer/${stripeCustomerID}`,
  );
}
